import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import "./CategoryAdmin.css"; // reuse same css
import CommonDrawer from "../common/CommonDrawer";
import { toast } from "react-toastify";

function ColorAdmin() {
  const [colors, setColors] = useState([]);
  const [name, setName] = useState("");
  const [hexCode, setHexCode] = useState("#000000");
  const [editId, setEditId] = useState(null);
  const [open, setOpen] = useState(false);

  const loadColors = async () => {
    const res = await axiosInstance.get("colors/");
    setColors(res.data);
  };

  useEffect(() => {
    loadColors();
  }, []);

  const saveColor = async () => {
    if (!name.trim()) return toast.error("Color name required");

    const payload = {
      name,
      hex_code: hexCode,
    };

    if (editId) {
      await axiosInstance.put(`colors/?id=${editId}`, payload);
    } else {
      await axiosInstance.post("colors/", payload);
    }

    resetForm();
    loadColors();
  };

  const resetForm = () => {
    setName("");
    setHexCode("#000000");
    setEditId(null);
    setOpen(false);
  };

  const editColor = (color) => {
    setEditId(color.id);
    setName(color.name);
    setHexCode(color.hex_code || "#000000");
    setOpen(true);
  };

  const deleteColor = async (id) => {
    if (window.confirm("Delete color?")) {
      await axiosInstance.delete(`colors/?id=${id}`);
      loadColors();
    }
  };

  return (
    <div className="category-admin">
      <div className="header">
        <h2>Colors</h2>
        <button
          className="primary-btn"
          onClick={() => {
            resetForm();
            setOpen(true);
          }}
        >
          + Add Color
        </button>
      </div>

      <div className="table">
        <div className="table-head">
          <span>Preview</span>
          <span>Name</span>
          <span>Actions</span>
        </div>

        {colors.map((color) => (
          <div className="table-row" key={color.id}>
            <div>
              <div
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  backgroundColor: color.hex_code || "#000",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <span className="name">
              {color.name}
              <br />
              <small>{color.hex_code}</small>
            </span>

            <div className="actions">
              <button className="edit" onClick={() => editColor(color)}>
                Edit
              </button>
              <button
                className="danger"
                onClick={() => deleteColor(color.id)}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* DRAWER */}
      <CommonDrawer
        open={open}
        title={editId ? "Edit Color" : "Add Color"}
        onClose={resetForm}
      >
        <input
          className="input"
          placeholder="Color name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <label style={{ marginBottom: "8px", display: "block" }}>
          Select Color
        </label>

        <input
          type="color"
          value={hexCode}
          onChange={(e) => setHexCode(e.target.value)}
          style={{
            width: "100%",
            height: "50px",
            border: "none",
            marginBottom: "20px",
          }}
        />

        <button className="primary-btn full" onClick={saveColor}>
          {editId ? "Update" : "Save"}
        </button>
      </CommonDrawer>
    </div>
  );
}

export default ColorAdmin;